import React from 'react';
import { map, get, noop, reduce } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsAlertsStatsWidget as MemberDetailsAlertsStatsWidget } from 'ui/views/widgets/memberDetailsAlertsStatsWidget';
 *
 * // render
 * <MemberDetailsAlertsStatsWidget propName='propValue'/>
 */
const _memberDetailsAlertsStatsWidget = ( props ) => {
    const { title, alertTypes, values } = props.componentData;
    
    const totalAlertsCount = reduce( values, ( sum, value ) => sum + value );

    const widgetClassName = classnames( 'ui-member-details-alerts-stats-widget', {
        'ui-member-details-alerts-stats-widget--clickable': totalAlertsCount
    } );
    
    return (
        <div className={ widgetClassName } onClick={ totalAlertsCount ? props.onCardClick : noop } >
            <div className='ui-member-details-alerts-stats-widget__info'>
                <div className='ui-member-details-alerts-stats-widget__info__title'>
                    { getLabel( title ) }
                </div>
                <div className='ui-member-details-alerts-stats-widget__info__sections'>
                    {
                        map( alertTypes, alertType => {
                            return (
                                <div key={ alertType.name } className='ui-member-details-alerts-stats-widget__info__sections__section'>
                                    <div className='ui-member-details-alerts-stats-widget__info__sections__section__count'>
                                        { get( values, `${ alertType.name }`, 0 ) }
                                    </div>
                                    <div className='ui-member-details-alerts-stats-widget__info__sections__section__title'>
                                        { getLabel( alertType.title ) }
                                    </div>
                                </div>
                            );
                        } )
                    }
                </div>
            </div>
            <div className='ui-member-details-alerts-stats-widget__icon'>
                <Icon name="alertStatsIcon" />
            </div>
        </div>
    );
};

// set display name
_memberDetailsAlertsStatsWidget.displayName = 'memberDetailsAlertsStatsWidget';

// set default props
_memberDetailsAlertsStatsWidget.defaultProps = {};

// prop types
_memberDetailsAlertsStatsWidget.propTypes = {};


// preloader
const memberDetailsAlertsStatsWidgetPreloader = () => {

    // reusing savings card preloader
    return (
        <div className='ui-member-details-header-widget-preloader__savings'>
            <div className='ui-member-details-header-widget-preloader__savings__name'>
            </div>
            <div className='ui-member-details-header-widget-preloader__savings__details'>
                <div className='ui-member-details-header-widget-preloader__savings__details__specific'>
                    <p className='ui-member-details-header-widget-preloader__savings__details__specific__title__preloader'></p>
                </div>
                <div className='ui-member-details-header-widget-preloader__savings__details__specific'>
                    <div className='ui-member-details-header-widget-preloader__savings__details__specific__icon__preloader'></div>
                </div>
            </div>
        </div>
    );
};

// set display name
memberDetailsAlertsStatsWidgetPreloader.displayName = 'memberDetailsAlertsStatsWidgetPreloader';

// set default props
memberDetailsAlertsStatsWidgetPreloader.defaultProps = {};

// prop types
memberDetailsAlertsStatsWidgetPreloader.propTypes = {};


export const memberDetailsAlertsStatsWidget = withNetworkState( memberDetailsAlertsStatsWidgetPreloader, _memberDetailsAlertsStatsWidget );
